export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_05-c64cade096f9561e6ed4502507efb709.jpg";